export default function filterParams<T extends object>(obj: T): Partial<T> {
  return (Object.keys(obj) as Array<keyof T>)
    .filter(key => obj[key] !== undefined && obj[key] !== '')
    .reduce((acc, key) => {
      acc[key] = obj[key];
      return acc;
    }, {} as Partial<T>);
}
